import { createAction } from 'redux-actions';

export const REPORT_STATE_ALL_YEARS = 'REPORT_STATE_ALL_YEARS';
export const REPORT_STATE_TOP_TEN = 'REPORT_STATE_TOP_TEN';
export const REPORT_STATE_ALL_CLASSES = 'REPORT_STATE_ALL_CLASSES';

export const SET_REPORT_STATE = 'SET_REPORT_STATE';

const setReportState = createAction(SET_REPORT_STATE);

export default {
    setReportState
};



// WEBPACK FOOTER //
// ./containers/participation/all-classes/report-state/report-state-actions.js